/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!--    <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入商家名称" @change="search"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit1()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column prop="mchId" label="id" width="200">
      </el-table-column>
      <el-table-column prop="name" label="商家名称" width="200">
      </el-table-column>
      <el-table-column prop="issue" label="问题" width="240">
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="400">
        <template slot-scope="scope">
          <div v-if="scope.row.mchId.length >10">
            <el-button size="mini" @click="handleEdit(scope.row.mchId,4)">修改基础信息</el-button>
            <el-button size="mini" @click="handleEdit(scope.row.mchId,1)">修改商家储值信息</el-button>
            <el-button size="mini" @click="handleEdit(scope.row.mchId,2)">修改银行卡</el-button>
          </div>
          <div v-else>
            <el-button size="mini" @click="xgkh(scope.row.mchId,3)">修改品牌信息</el-button>
            <el-button size="mini" @click="xgkh(scope.row.mchId,2)">修改银行卡</el-button>
            <el-button size="mini" @click="xgkh(scope.row.mchId,1)">修改折扣</el-button>
          </div>

        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import {
    bustList,
    addMerchant,
    getMchInfoEmpty
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          cityId: localStorage.getItem('cityId1'),
          name: '',
          addr: ''
        },
        formInline: {
          page: 1,
          limit: 20,
          varLable: '',
          varName: '',
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        let pro = {

        }
        getMchInfoEmpty(pro)
          .then(res => {
            this.loading = false
            if (res.baseInfo.code == 1) {
              this.$message({
                type: 'info',
                message: res.baseInfo.message
              })
            } else {
              this.listData = res.data

            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1
        this.getdata(this.formInline)
      },
      handleEdit99: function(index, row) {
        this.$router.push({
          name: 'clerk1',
          query: {
            id: row
          }
        })
      },
      xgkh(id, type) {
        console.log(id, type)
        if (type == 1) {
          this.$router.push({
            name: '修改品牌折扣',
            query: {
              id: id
            }
          })

        } else if (type == 2) {
          this.$router.push({
            name: '修改品牌银行卡',
            query: {
              id: id
            }
          })

        } else if (type == 4) {
          this.$router.push({
            name: '品牌商家列表',
            query: {
              id: id
            }
          })
        } else {
          this.$router.push({
            name: '修改品牌信息',
            query: {
              id: id
            }
          })
        }
      },
      //显示编辑界面
      handleEdit: function(row, type) {
        if (type == 1) {
          this.$router.push({
            name: '修改商家储值信息',
            query: {
              id: row
            }
          })
        } else if (type == 2) {
          this.$router.push({
            name: '修改银行卡',
            query: {
              id: row
            }
          })
        } else if (type == 4) {
          console.log(4)
          const {
            href
          } = this.$router.resolve({
            path: '/bus/modifyMerchantsBasis',
            query: {
              id: row
            }
          })
          window.open(href, '_blank')
        } else if (type == 5) {
          let pro = {
            "data": {
              "mchId": row
            }
          }
          synMerchantYxf3(pro)
            .then(res => {
              this.loading = false
              if (res.baseInfo.code == 1) {
                this.$message({
                  type: 'info',
                  message: res.baseInfo.message
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '商家同步成功！'
                })
              }
            })
        }
      },
      //显示编辑界面
      handleEdit1(index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = '修改'

        } else {
          this.title = '添加'
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.loading = true
        let pro = {
          "data": this.editForm
        }
        addMerchant(pro)
          .then(res => {
            this.loading = false
            if (res.baseInfo.code == 1) {
              this.$message({
                type: 'info',
                message: res.baseInfo.message
              })
            } else {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: '商家添加成功！'
              })
              this.closeDialog()
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false
      }

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/bus/wtbus.vue